import { NgModule }      from '@angular/core';
import { TagItemModule } from './tag-item/tag-item.module';
import { TagListModule } from './tag-list/tag-list.module';


@NgModule( {
	declarations: [],
	imports: [],
	exports: [
		TagItemModule,
		TagListModule
	]
} )
export class TagModule {}
